Vue.component('info-page', {
	template: '#vue-info-page',
    props: {
      infoClass: { default: 'default' },
      imgSize: { default: 4 },
	  icon: { default: 'info' },
      text1: { default: locales('components.info-page.js.error') },
      text2: { default: '' },
      backHome: { default: 0 }
    }
});

Vue.component('info', {
    template: '#vue-info',
	props: {
	  infoClass: { default: 'default' },
      imgSize: { default: 4 },
	  icon: { default: 'info' },
      text1: { default: locales('components.info-page.js.error') },
      text2: { default: '' },
      backHome: { default: 0 }
    }
});
